const productSizeGuide = {
    modal: null,
    openButton: null,
    closeButton: null,
    selectors: {
        modal: '#js-sizeGuideModal',
        openButton: "#js-sizeGuideButton",
        closeButton: '#js-sizeGuideClose',
    },
    init: function () {
        this.initElements();
        if (this.modal.length) {
            this.openButton.click(() => this.open());
            this.closeButton.click(() => this.close());
        }
    },
    initElements() {
        this.modal = $(this.selectors.modal);
        this.openButton = $(this.selectors.openButton);
        this.closeButton = $(this.selectors.closeButton)
    },
    open: function () {
        this.modal.addClass('visible');
        $('body').addClass('body-lock');
    },
    close: function() {
        this.modal.removeClass('visible');
        $('body').removeClass('body-lock');
    },
}


window.addEventListener('load', function() {
    productSizeGuide.init();
})